<template>

  <div class="fit-content">
    <div class="d-flex align-items-center justify-content-between">
        <b-form-checkbox
          v-model="isSelected"
          :name="'selected-food-'+food.id"
          :value="true"
          :unchecked-value="false"
        >
          <strong>{{ food.name }}</strong>
        </b-form-checkbox>
    </div>

    <div class="mt-2">
      <b-form-group class="fluid">
        <b-form-radio-group
          class="food-percentage-group"
          v-model="eatenPercentage.value"
          :options="eatenPercentageOptions"
          button-variant="outline-secondary"
          name="eatenPercentage-radio"
          :disabled="!isSelected"
          :size="isSmallScreen ? 'sm' : 'md'"
          buttons
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </div>

</template>

<script>

export default {

  name: "DailyStatusCardFoodRow",

  props: {

    food: {
      type: Object,
      required: true
    },

    dailyFood: {
      type: Object,
      required: false
    }

  },

  mounted() {
    this.setInitialValues()
  },

  data(){
    return {
      isSelected: false,

      eatenPercentage: {
        state: null,
        invalidFeedback: null,
        value: 50
      },

      eatenPercentageOptions: [
        { text: '0%', value: 0 },
        { text: '25%', value: 25 },
        { text: '50%', value: 50 },
        { text: '75%', value: 75 },
        { text: '100%', value: 100 }
      ]
    }
  },

  watch: {
    'isSelected': function (newValue, oldValue) {
      this.updateFoodRow()
    },
    'eatenPercentage': function (newValue, oldValue) {
      this.updateFoodRow()
    },
  },

  computed : {
    isSmallScreen() {
       return window.innerWidth < 900
    }
  },

  methods: {

    updateFoodRow: function() {

      let row = {
        foodId: this.food.id,
        isSelected: this.isSelected,
        eatenPercentage: this.isSelected ? this.eatenPercentage : null
      }

      this.$emit("updateFoodRow", row)
    },

    setInitialValues: function() {

      if (!this.dailyFood) {
        return
      }

      this.isSelected = true
      this.eatenPercentage.value = this.dailyFood.eatenPercentage
    }
  }
}
</script>

<style scoped>
.input-group-text {
  padding: 2px 10px;
}
.fit-content{
  max-width: fit-content;
}

.food-percentage-group >>> .btn-outline-secondary:not(:disabled):not(.disabled).active,
.food-percentage-group >>> .btn-outline-secondary:not(:disabled):not(.disabled):active,
.food-percentage-group >>> .show > .btn-outline-secondary.dropdown-toggle {
  background-color: var(--main-color) !important;
  border-color: var(--main-color) !important;
  color: var(--main-white) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/cards/DailyStatusCardFoodRow.vue